import React, { forwardRef } from 'react';
import { Types } from '@fiverr-private/theme';
import Flex from '../Flex';

const Wrap = forwardRef<HTMLElement, Types.FlexLayoutProps>(
  ({ children, gap = { default: '3' }, wrap = { default: 'wrap' }, ...restProps }: Types.FlexLayoutProps, ref) => (
    <Flex ref={ref} gap={gap} wrap={wrap} {...restProps}>
      {children}
    </Flex>
  )
);

Wrap.displayName = 'Wrap';

export default Wrap;
